import React from 'react'
import { Card } from 'reactstrap';

const CategoryDetailsCard = (props) => {

    const headerValueArr = [
        { header: 'Code', field: 'code' },
        { header: 'Category', field: 'categoryName' },
        { header: 'Sub Category', field: 'subCategoryName' },
        { header: 'Sub Sub Category', field: 'subSubCategoryName' },
        { header: 'Description', field: 'description' },
    ]
    return (
        <Card className="p-2 w-100 mb-0 ">
            {headerValueArr?.map(el => {
                return props[el.field] && <div className="m-1" style={{ fontSize: '14px' }}>
                    <span className='font-weight-bold'>{`${el.header} : `}</span>
                    <span>{props[el.field]}</span>
                </div>
            })}
        </Card>
    );
}

export default CategoryDetailsCard;